export const apiMethods = appUrl => {
    return [
        {
            name: 'PlayerLogin',
            method: () => {
                return 'player/login';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'email',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'login_type',
                    processArgs: val => {
                        return 'desktop';
                    },
                },
                {
                    name: 'remember',
                    processArgs: val => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'PlayerLoginPTA',
            method: () => {
                return 'player/login';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'hash',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'iv',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'data',
                    processArgs: val => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'getSpatWithJwt',
            method: () => {
                return 'player/spat';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'EnterTicket',
            method: () => {
                return 'ticket/enter';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'ticket_number',
                    processArgs: val => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CheckTicket',
            method: () => {
                return 'ticket/check';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'ticket_number',
                    processArgs: val => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetRewards',
            method: () => {
                return 'query/rewards';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'pagesize',
                    processArgs: val => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: val => {
                        return val ? val : 1;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetPoints',
            method: () => {
                return 'player/balances/points';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'limit',
                    processArgs: val => {
                        return 'award';
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetActivity',
            method: () => {
                return 'query/activity';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'pagesize',
                    processArgs: val => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: val => {
                        return val || 1;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetPromotions',
            method: () => {
                return 'query/promotions';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetPlayerPromotions',
            method: () => {
                return 'query/promotions';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'Feedback',
            method: () => {
                return 'feedback';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'ConnectionSpeed',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'EmailAddress',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'FirstName',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'FlashVersion',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'IssueCategory',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'IssueDay',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'IssueDescription',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'IssueMonth',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'IssueType',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'IssueYear',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'IssueZone',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'LastName',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'Phone',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'Promotion',
                    processArgs: val => {
                        return val;
                    },
                },
                {
                    name: 'ZipCode',
                    processArgs: val => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetSweeps',
            method: urlArgs => {
                return `query/sweepstake/activePlayerEntries${urlArgs.sweeps_id}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'sweeps_id',
                    processArgs: val => {
                        return '/' + val;
                    },
                },
            ],
        },
        {
            name: 'Winners',
            method: urlArgs => {
                return `sweepstake/drawing/${urlArgs.drawing_id}/winners`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'Authorization',
                    processHeader: val => {
                        return `Bearer ${val}`;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: val => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'drawing_id',
                    processArgs: val => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'GetConfig',
            method: () => {
                return 'config/frontend';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetRevealToken',
            method: () => {
                return 'reveal/token';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
    ];
};
